import { create } from 'zustand';

interface DiffZoomStore {
  lastSelectedDifferenceId: string | null;
  lastSelectionAtMs: number | null;
  consumedForSelection: boolean;
  markSelection: (differenceId: string) => void;
  consumeIfWithin: (windowMs: number) => boolean;
  getLastSelectionId: () => string | null;
}

export const useDiffZoomStore = create<DiffZoomStore>((set, get) => ({
  lastSelectedDifferenceId: null,
  lastSelectionAtMs: null,
  consumedForSelection: false,
  markSelection: (differenceId: string) =>
    set(() => ({
      lastSelectedDifferenceId: differenceId,
      lastSelectionAtMs: Date.now(),
      consumedForSelection: false,
    })),
  consumeIfWithin: (windowMs: number) => {
    const { lastSelectionAtMs, consumedForSelection } = get();
    if (!lastSelectionAtMs) return false;
    const within = Date.now() - lastSelectionAtMs <= windowMs;
    if (within && !consumedForSelection) {
      set(() => ({ consumedForSelection: true }));
      return true;
    }
    return false;
  },
  getLastSelectionId: () => get().lastSelectedDifferenceId,
}));
